<div  [ngClass]="{'disabled': disabled ,'pre-load':preload}" class="preview-navigation d-flex align-items-center justify-content-end" (click)="NavigatetoPreviousPage()">
    <i class="fa fa-chevron-left" title="Previour" aria-hidden="true"></i>
</div>